import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  rates: [],
  lastUpdated: null,
};

const liveRateSlice = createSlice({
  name: "liveRate",
  initialState,
  reducers: {
    setLiveRates(state, action) {
      state.rates = action.payload;
      state.lastUpdated = Date.now();
    },
  },
});

export const { setLiveRates } = liveRateSlice.actions;
export default liveRateSlice.reducer;
